export const competitionCompModelCodes = ({ modelCompetition }, { modelId }) =>
  modelCompetition.byId[modelId] && modelCompetition.byId[modelId].compModels;

export const competitionData = ({ modelCompetition }, { modelId }) =>
  modelCompetition.byId[modelId] &&
  modelCompetition.byId[modelId].distributions;

export const compModelCode = ({ modelCompetition }, { modelId }) =>
  modelCompetition.byId[modelId] &&
  modelCompetition.byId[modelId].compModelCode;
